"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCT_INFO_DIALOG_DIALOG = void 0;
const PRODUCT_INFO_DIALOG_DIALOG = exports.PRODUCT_INFO_DIALOG_DIALOG = 'product-info-dialog-dialog';